import type { DashboardState } from "./shared/types";

const TOKEN_KEY = "tunnel-watch-admin-token";

export function readStoredToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function storeToken(token: string) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function fetchState(token: string): Promise<DashboardState> {
  const response = await fetch("/api/state", {
    headers: authHeaders(token),
    cache: "no-store"
  });
  return parseResponse(response);
}

export async function refreshServer(token: string, serverId: string) {
  const response = await fetch("/api/refresh", {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ serverId })
  });
  return parseResponse(response);
}

function authHeaders(token: string): Record<string, string> {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function parseResponse(response: Response) {
  const text = await response.text();
  const data = text ? JSON.parse(text) : {};
  if (!response.ok) {
    throw new Error(data.error || `HTTP ${response.status}`);
  }
  return data;
}
